import { render, staticRenderFns } from "./CallsTab.vue?vue&type=template&id=c6e6ad90&scoped=true"
import script from "./CallsTab.vue?vue&type=script&lang=js"
export * from "./CallsTab.vue?vue&type=script&lang=js"
import style0 from "./CallsTab.vue?vue&type=style&index=0&id=c6e6ad90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6e6ad90",
  null
  
)

export default component.exports